// import React from "react";
// import background from "../assets/background.svg";
// import rightImage from "../assets/image-right.svg"; 
// import "../styles.css"; 

// const HeroSection = () => {
//   return (
//     <section id="HeroSection" className="hero-section">
//       {/* Background Image Behind Everything */}
//       <img src={background} alt="Background" className="hero-background" />

//       <div className="hero-left-container">
//         {/* Main Heading */}
//         <h1 className="hero-title">Build your next <br /> project faster.</h1>

//         {/* Subtitle */}
//         <p className="hero-subtitle">
//           We make your vision to reality to create something valuable with our
//           intensive tech skills and commitments.
//         </p>

//         {/* Email Input + Button */}
//         <div className="hero-input-container">
//           <input type="email" placeholder="Enter your mail address" className="hero-input" />
//           <button className="hero-button">Get Started</button>
//         </div>

//         {/* Features Section */}
//         <div className="hero-features">
//           <span className="feature-item">✔ Talented Team</span>
//           <span className="feature-item">✔ Reliable Technology Development</span>
//         </div>
//       </div>

//       {/* Right Side Image */}
//       <img src={rightImage} alt="Illustration" className="hero-image-right" />
//     </section>
//   );
// };

// export default HeroSection;

import React, { useState } from "react";
import background from "../assets/background.svg";
import rightImage from "../assets/image-right.svg"; 
import "../styles.css"; 
import ModalWrapper from "../Components-2/ModalWrapper"; 
import Booking from "../Components-2/Booking";

const HeroSection = () => {
  const [email, setEmail] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleGetStarted = () => {
    if (!email) {
      alert("Please enter a valid email first.");
      return;
    }
    setOpenModal(true);
  };

  return (
    <section id="HeroSection" className="hero-section">
      {/* Background Image */}
      <img src={background} alt="Background" className="hero-background" />

      <div className="hero-left-container">
        <h1 className="hero-title">Build your next <br /> project faster.</h1>
        <p className="hero-subtitle">
          We make your vision to reality to create something valuable with our
          intensive tech skills and commitments.
        </p>

        {/* Email Input + Button */}
        <div className="hero-input-container">
          <input
            type="email"
            placeholder="Enter your mail address"
            className="hero-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="hero-button" onClick={handleGetStarted}>
            Get Started
          </button>
        </div>

        {/* Features Section */}
        <div className="hero-features">
          <span className="feature-item">✔ Talented Team</span>
          <span className="feature-item">✔ Reliable Technology Development</span>
        </div>
      </div>

      {/* Right Side Image */}
      <img src={rightImage} alt="Illustration" className="hero-image-right" />

      {/* ✅ Booking Modal with prefilled email */}
      <ModalWrapper show={openModal} onClose={() => setOpenModal(false)}>
        <Booking prefilledEmail={email} />
      </ModalWrapper>
    </section>
  );
};

export default HeroSection;
